import { render } from "./TestUCPreload.vue?vue&type=template&id=0057dcb1"
import script from "./TestUCPreload.vue?vue&type=script&lang=js"
export * from "./TestUCPreload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__